<template>
  <b-dropdown-item
    link-class="d-flex align-items-center justify-content-between"
    class="connection-status"
    @click.prevent
  >
    <div
      v-b-tooltip
      class="d-flex align-items-center"
      :title="$t(tooltipKey)"
    >
      <feather-icon
        size="16"
        icon="WifiIcon"
        :class="['mr-50', iconClass]"
      />
      <span :class="iconClass">
        {{ $t(labelKey) }}
      </span>
    </div>
  </b-dropdown-item>
</template>

<script>
import { BDropdownItem, VBTooltip } from 'bootstrap-vue'
import { networkStatus } from '@/helpers/networkStatus'

export default {
  name: 'ConnectionStatusItem',
  components: { BDropdownItem },
  directives: { 'b-tooltip': VBTooltip },
  computed: {
    status() {
      return networkStatus.status
    },
    iconClass() {
      if (this.status === 'online') {
        return 'text-success'
      }

      if (this.status === 'offline') {
        return 'text-danger'
      }

      return 'text-warning'
    },
    labelKey() {
      return `user-profile.connection-status.${this.status}.label`
    },
    tooltipKey() {
      return `user-profile.connection-status.${this.status}.tooltip`
    },
  },
}
</script>
